import React, {useEffect, useState} from 'react';
import { getUserInfo } from '../utils/token';
import SubscriptionWidget from '../components/common/SubscriptionWidget';
import CustomerUsage from '../components/dashboardWidgets/CustomerUsage';

const DashboardPage = () => {
  const [companyId, setCompanyId] = useState(null);
  const [customerId, setCustomerId] = useState(null);
  const [role, setRole] = useState(null);

  useEffect(()=>{
    async function fetchData() {
      const {compId, userId, role} = getUserInfo();
      console.log(compId);
      setCompanyId(compId);
      setCustomerId(userId);
      setRole(role);
    }
    fetchData();  
  },[]);

  return (
    <div className="dashboard-page">
      <h1 className="mb-4">Welcome to the Mymessages a Whatsapp Gateway</h1>
      <p>It's a secure and scalable API platform for sending and receiving WhatsApp messages, with multi-device support and real-time communication.</p>
      {
        role === 'Customer' && (
          <SubscriptionWidget 
            compId ={companyId}
            customerId = {customerId}
          />
        )
      }
      
    </div>
  );
};

export default DashboardPage;